import { formatCurrency } from "../utils/utils";
import { TariffDetailRevamp } from "./tariffDetailRevamp";

export class TariffsRevamp {
  constructor(code, description, name, tariffs) {
    this.code = code;
    this.description = description;
    this.name = name;
    /**@type {[TariffDetailRevamp]} */
    this.tariffs = tariffs;
  }
  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      return new TariffsRevamp(
        input.code,
        input.description,
        input.name,
        TariffDetailRevamp.fromApiArray(input.tariffs),
      );
    }
    return new TariffsRevamp();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => TariffsRevamp.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [TariffsRevamp.fromApiObject(input)];
    }
    return [];
  }

  genRequirement() {
    let result = "";
    this.requirements.forEach((element, index) => {
      result += element.genHtml();
    });
    return result;
  }

  genDetailHtml(isCalculate, currency) {
    let translate = window.searchData.destination === "NO" ? ' class="translate"' : "";

    let result = "";
    this.tariffs.sort((a, b) => {
      if (a.selected && !b.selected) return -1;
      if (!a.selected && b.selected) return 1;
      return 0;
    });
    this.tariffs.forEach((element, index) => {
      // const value = element.highlight ? element.valueText : element.valueText.replace(element.highlight, `<b style="background: #FFFE54;">${element.highlight}</b>`);
      result += `<tr class="item ${element.selected ? "selected" : "unselected"}">
        <td${translate}>${element.name}</td$>
        ${isCalculate ? `
          <td align="right">
            <b>${currency ? currency + " " : ""}${formatCurrency(element.amount)}</b>
          </td>
          ` : ""}
        <td${translate} width="150">${element.formula}</td$>
        <td width="150">
        ${element.condition && `
          <span style="text-decoration: underline; color: #007bff; cursor: pointer;" data-condition="${encodeURIComponent(element.condition)}" class="condition-link">Conditions</span>
          `}
        </td$>
        <td width="40%">
          <span class="showmore-element" data-config='{ "type": "text", "limit": 120, "more": "→ show more", "less": "← less" }'>${element.description}</span>
        </td>
      </tr>`
    });

    return result;
  }
}